"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadataUtil = void 0;
const tslib_1 = require("tslib");
const crypto_1 = require("crypto");
const path = tslib_1.__importStar(require("path"));
const globalVars_1 = require("../../common/globalVars");
const telemetry_1 = require("../../common/telemetry");
const interface_1 = require("../configManager/interface");
const parser_1 = require("../configManager/parser");
const metadataDAProperties_1 = require("./metadataDAProperties");
const metadataGraphPermssion_1 = require("./metadataGraphPermssion");
const metadataRscPermission_1 = require("./metadataRscPermission");
class MetadataUtil {
    async parse(ymlPath) {
        const res = await parser_1.yamlParser.parse(ymlPath, true);
        const fileName = path.basename(ymlPath);
        const props = {};
        props[telemetry_1.TelemetryProperty.YmlName] = fileName.split(".").join("");
        if (res.isOk()) {
            for (const name of interface_1.LifecycleNames) {
                const str = res.value[name]?.driverDefs
                    .map((def) => def.uses)
                    .toString()
                    .split("/")
                    .join("");
                props[name + ".actions"] = str ?? "";
            }
            props[telemetry_1.TelemetryProperty.YmlSchemaVersion] = res.value.version;
            props[telemetry_1.TelemetryProperty.SampleAppName] = MetadataUtil.parseSampleTag(res.value.additionalMetadata);
            await metadataGraphPermssion_1.metadataGraphPermissionUtil.parseAadManifest(ymlPath, res.value, props);
            await metadataRscPermission_1.metadataRscPermissionUtil.parseManifest(ymlPath, res.value, props);
            await metadataDAProperties_1.metadataDAPropertiesUtil.parseManifest(ymlPath, res.value, props);
            globalVars_1.TOOLS.telemetryReporter?.sendTelemetryEvent(telemetry_1.TelemetryEvent.MetaData, props);
        }
        return res;
    }
    static parseSampleTag(additionalMetadata) {
        if (additionalMetadata === undefined) {
            return "";
        }
        const sampleTag = additionalMetadata["sampleTag"];
        if (typeof sampleTag === "string") {
            // replace characters that could make the tag be mistaken as a file path or an email address
            return sampleTag.replace(/[@\/\\\.]/g, "_");
        }
        else {
            return "";
        }
    }
    parseManifest(manifest) {
        const props = {};
        const prefix = "manifest.";
        props[prefix + "id"] = manifest.id ?? "";
        props[prefix + "version"] = manifest.version ?? "";
        props[prefix + "manifestVersion"] = manifest.manifestVersion ?? "";
        props[prefix + "bots"] = manifest.bots?.map((bot) => bot.botId).toString() ?? "";
        props[prefix + "composeExtensions"] =
            manifest.composeExtensions?.map((bot) => bot.botId).toString() ?? "";
        props[prefix + "staticTabs.contentUrl"] =
            manifest.staticTabs
                ?.map((tab) => tab.contentUrl ? (0, crypto_1.createHash)("sha256").update(tab.contentUrl).digest("hex") : "undefined")
                .toString() ?? "";
        props[prefix + "configurableTabs.configurationUrl"] =
            manifest.configurableTabs
                ?.map((tab) => tab.configurationUrl
                ? (0, crypto_1.createHash)("sha256").update(tab.configurationUrl).digest("hex")
                : "undefined")
                .toString() ?? "";
        props[prefix + "webApplicationInfo.id"] = manifest.webApplicationInfo?.id ?? "";
        props[prefix + "extensions"] =
            "extensions" in manifest && manifest["extensions"]?.length != 0 ? "true" : "false";
        globalVars_1.TOOLS.telemetryReporter?.sendTelemetryEvent(telemetry_1.TelemetryEvent.MetaData, props);
    }
}
exports.metadataUtil = new MetadataUtil();
//# sourceMappingURL=metadataUtil.js.map